import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/suppliers/$supplierId/locations")({
  component: lazyRouteComponent(() => import("./+SupplierLocations")),
  beforeLoad: () => ({
    breadcrumb: "Locations",
  }),
});
